export default class SettingsPersistor
{
  public static save(setting: string, value: any) {
    const settingsString = localStorage.getItem('a11y-settings');
    let settings = settingsString ? JSON.parse(settingsString) : {};
    settings[setting] = value;
    localStorage.setItem('a11y-settings', JSON.stringify(settings));
  }

  public static load() {
    const settingsString = localStorage.getItem('a11y-settings');
    return settingsString ? JSON.parse(settingsString) : {};
  }

  public static reset() {
    localStorage.removeItem('a11y-settings');
  }
}